export default __webpack_public_path__ + "static/media/LogoEBDColorida.b771550d.png";